<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<p>Books normally have an introduction and although I’ve written some odd things in my book, I do consider myself to be fairly normal.</p>
<p>However, I have been called a few things in my time and one of them was being a big head.</p>
<p>Mainly because I do know a lot of things. People have said ‘how come you know so much?’ And my answer has usually been the same. How long is an apprenticeship? Five years, how old am I? I have had time for a few apprenticeships and I love learning.</p>
<p>So, I have written my life story as it has been to the best of my knowledge and included a lot of the things I have done and achieved and I will say I am proud of most of them.</p>
<p>But it is common knowledge that no one is perfect and I admit I have done a couple of things I maybe shouldn’t have. Never, ever anything bad but usually trying to help someone when I should have minded my own business.</p>
<p>So, I apologise if I have over promoted myself, but this is me. (Blame me, mam n dad!)</p><br/>
<p>All people and characters mentioned in this book have been done so with all good intentions and just been included as fact during my life. Some names have been changed for legal reasons.</p><br/>
<p>I have written it as it happened and history is a fact and cannot be changed.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?1b8c5340